import { Component, inject, input, OnInit, ViewChild } from '@angular/core';
import { ChartType } from 'chart.js';
import { v4 } from 'uuid';
import {
  CellColoring,
  CustomTableCell,
  ExtraBodyParams,
  GlobalAction,
  RowAction,
  TABLE_DATA_PROVIDER,
  TableRow,
} from '../table.interface';
import { TableApiService } from '../../../services/table/table-api.service';
import { TableComponent } from '../table.component';
import { TABLE_CONFIG, TableConfig } from '../table-config';

@Component({
  selector: 'app-api-table',
  imports: [TableComponent],
  providers: [
    { provide: TABLE_CONFIG, useExisting: APITableComponent },
    {
      provide: TABLE_DATA_PROVIDER,
      useClass: TableApiService,
    },
  ],
  template: ` <app-table /> `,
})
export class APITableComponent implements TableConfig, OnInit {
  // ----------- inputs ---------------------------

  endpoint = input.required<string>();
  name = input<string>(v4().split('-')[0]);
  controls = input<boolean>(true);
  static = input<boolean>(false);
  canExport = input<boolean>(true);
  canCopy = input<boolean>(true);
  canSelect = input<boolean>(false);
  selectOptions = input<GlobalAction>();
  chartType = input<ChartType>('bar');
  groupCells = input<boolean>(false);
  hasIndexCol = input<boolean>(false);
  actionCol = input<RowAction[]>([]);
  chartColumn = input<string>();
  coloring = input<CellColoring>();
  customCells = input<CustomTableCell[]>([]);
  onRowClick = input<(Row: TableRow) => void>();
  hasChartView = input<boolean>(true);
  defaultSort =  input<Record<string, 'asc' | 'desc'>>();
  DeletedRowsStyle = input<boolean>(false);

  /** Generic extra body parameters to be appended to API request bodies */
  extraBody = input<ExtraBodyParams>();
  /** When true, filters and getAvailableFilters are not sent to the API */
  skipFilters = input<boolean>(false);
  /** When true, the global from/to date range is not sent to the API */
  skipDateRange = input<boolean>(false);
  // ---------------- services -----------------------
  dataProviderService = inject(TABLE_DATA_PROVIDER) as TableApiService;
  // ---------------- Child components -----------------------
  @ViewChild(TableComponent) tableComponent!: TableComponent;
  // ----------- Managing state changes ---------------

  ngOnInit() {
    this.dataProviderService.initialize(this.endpoint());
  }

  /**
   * Refreshes the table data by re-initializing the table context.
   * Call this method after modifying data (e.g., after approve/reject operations).
   */
  refresh(): void {
    if (this.tableComponent?.tableContext) {
      this.tableComponent.tableContext.initialize().subscribe({
        next: () => {
          this.tableComponent.tableContext.setIsLoading(false);
        },
        error: () => {
          this.tableComponent.tableContext.setIsLoading(false);
          this.tableComponent.tableContext.markInitializedAfterError();
        },
      });
    }
  }

  /** Refreshes the current page without resetting search, filters, or sorting. */
  refreshCurrentView(): void {
    if (this.tableComponent?.tableContext) {
      this.tableComponent.tableContext.refreshCurrentView().subscribe({
        error: () => {
          this.tableComponent.tableContext.setIsLoading(false);
        },
      });
    }
  }
}
